import { languages_config } from '@acri-tools/react-tools/utils/languages';

import en from './en';

export default {
    'en': {
        ...languages_config.languages['en'],
        ...en
    }
}
